import winRateService from '~/services/dashboard/winRate.service';
import * as http from '~/utils/apis';

const winRateApi = {
    getAll: async (params) => {
        const { page, perPage } = params;
        const res = await http.get(`cms-api/dashboard/win-rate`, { page, perPage });
        if (res) {
            const rows = winRateService.processWinRateApiData(res.data.data);
            const totalRows = res.data.meta.total;
            return { rows, totalRows };
        }
    },
};

export default winRateApi;
